import { useMsal } from "@azure/msal-react";
import { PrimaryButton } from "@fluentui/react";
import { loginRequest } from "../shared/authConfig";

const LoginButton = ({ text, setLoginError, forceSelectAccount, ...buttonProps }) => {
  const { instance } = useMsal();

  const handleLogin = () => {
    setLoginError(null);
    const req = forceSelectAccount
      ? { ...loginRequest, prompt: "select_account" }
      : loginRequest;

    instance.loginRedirect(req).catch((e) => {
      console.log("Error in Redirect Login:", e);
      setLoginError("Login failed: " + e);
    });
  };

  return <PrimaryButton onClick={handleLogin} text={text} {...buttonProps} />;
};

export default LoginButton;
